import type {
  BillingContactResponse,
  CompanyBillingSetupRequest,
  CompanyBillingSetupResponse,
  SetBillingContactRequest,
  User,
} from '../types/user'
import { api } from './fetch'

export const companyService = {
  // Get list of team members for billing contact selection (includes current user)
  async getTeamMembers(): Promise<User[]> {
    const response = await api.get('/team/members/')
    return response.data
  },

  // Get current billing contact
  async getBillingContact(): Promise<BillingContactResponse> {
    const response = await api.get('/user/company/billing-contact')
    return response.data
  },

  // Set billing contact (OWNER only)
  async setBillingContact(
    data: SetBillingContactRequest,
  ): Promise<BillingContactResponse> {
    const response = await api.post('/user/company/billing-contact', data)
    return response.data
  },

  // Setup company billing (Billing contact or owner only)
  async setupCompanyBilling(
    data: CompanyBillingSetupRequest,
  ): Promise<CompanyBillingSetupResponse> {
    const response = await api.post('/user/company/setup-billing', data)
    return response.data
  },

  // Get current subscription status (if any)
  async getSubscriptionStatus(): Promise<CompanyBillingSetupResponse | null> {
    try {
      const response = await api.get('/user/company/subscription-status')
      return response.data
    } catch (error: unknown) {
      // If 404, no subscription exists
      if (
        error &&
        typeof error === 'object' &&
        'response' in error &&
        error.response &&
        typeof error.response === 'object' &&
        'status' in error.response &&
        error.response.status === 404
      ) {
        return null
      }
      throw error
    }
  },
}
